import {computed, defineComponent} from 'vue';
import {isEmpty} from 'lodash-es';
import {Message} from 'primevue';

export default defineComponent({
    name: 'AegFieldValidationWrapper',
    components: { Message },
    props: {
        errorMessage: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            required: true,
        },

        rulesLabelOverride: { type: String, default: '' },
        modHiddenLabel: { type: Boolean, default: false, required: false },
        annotation: { type: String, required: false, default: undefined },

        // TO REVIEW
        modRequired: { type: Boolean, default: false, required: false },
        modNoWrapError: { type: Boolean, default: false, required: false },
        modNoWrapAnnotation: { type: Boolean, default: false, required: false },
    },
    setup(props) {

        const hasError = computed((): boolean => !isEmpty(props.errorMessage));
        const errors = computed((): string[] => props.errorMessage ? [props.errorMessage] : []);
        const label = computed((): string => props.name);

        const rulesLabel = computed((): string => {
            // label = label bij het veld in de ui
            // rulesLabel = naam van het veld in de error text + deze moet uniek zijn binnen de form
            if (props.rulesLabelOverride) {
                return props.rulesLabelOverride;
            }
            return label.value;
        });

        return {
            label,
            rulesLabel,

            hasError,
            errors,
        }
    }
})
